/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { EuiContextMenuItem } from '../../context_menu';
export var EuiTableSortMobileItem = ({
  children,
  onSort,
  isSorted,
  isSortAscending,
  className,
  ariaLabel,
  ...rest
}) => {
  let sortIcon = 'empty';

  if (isSorted) {
    sortIcon = isSortAscending ? 'sortUp' : 'sortDown';
  }

  const buttonClasses = classNames('euiTableSortMobileItem', className, {
    'euiTableSortMobileItem-isSorted': isSorted
  });
  const columnTitle = ariaLabel ? ariaLabel : children;
  const statefulAriaLabel = `Sort ${columnTitle} ${isSortAscending ? 'descending' : 'ascending'}`;
  return <EuiContextMenuItem className={buttonClasses} icon={sortIcon} onClick={onSort} aria-label={statefulAriaLabel} {...rest}>
      {children}
    </EuiContextMenuItem>;
};
EuiTableSortMobileItem.propTypes = {
  /**
     * Callback to know when an item has been clicked
     */
  onSort: PropTypes.func,

  /**
     * Indicates current option is the sorted on column
     */
  isSorted: PropTypes.bool,

  /**
     * Indicates which direction the current column is sorted on
     */
  isSortAscending: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};

try {
  // @ts-ignore
  EuiTableSortMobileItem.displayName = "EuiTableSortMobileItem"; // @ts-ignore

  EuiTableSortMobileItem.__docgenInfo = {
    "description": "",
    "displayName": "EuiTableSortMobileItem",
    "props": {
      "onSort": {
        "defaultValue": null,
        "description": "Callback to know when an item has been clicked",
        "name": "onSort",
        "required": false,
        "type": {
          "name": "(() => void) | undefined"
        }
      },
      "isSorted": {
        "defaultValue": null,
        "description": "Indicates current option is the sorted on column",
        "name": "isSorted",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "isSortAscending": {
        "defaultValue": null,
        "description": "Indicates which direction the current column is sorted on",
        "name": "isSortAscending",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      },
      "ariaLabel": {
        "defaultValue": null,
        "description": "",
        "name": "ariaLabel",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-label": {
        "defaultValue": null,
        "description": "",
        "name": "aria-label",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "data-test-subj": {
        "defaultValue": null,
        "description": "",
        "name": "data-test-subj",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/table/mobile/table_sort_mobile_item.tsx#EuiTableSortMobileItem"] = {
      docgenInfo: EuiTableSortMobileItem.__docgenInfo,
      name: "EuiTableSortMobileItem",
      path: "src/components/table/mobile/table_sort_mobile_item.tsx#EuiTableSortMobileItem"
    };
} catch (__react_docgen_typescript_loader_error) {}